import React, { useEffect } from 'react';
import IconLabel from '../../../../../components/iconlabel/IconLabel';
import { useState } from 'react';
import { VEC_ICON_NAME } from '../../../../../components/icons/constants';
import styles from './AddNewAddress.styles';
import commonStyles from "../../PaymentDrawer.styles"
import TextInput from '../../../../../components/input/textinput/TextInput';
import Loadable from '../../../../../components/loadable/Loadable';
import { ADDRESS_INFORMATION_LOADING_STATES, ADDRESS_INFORMATION_MESSAGE_MAP } from '../constants';
import { validateZipCode } from '../AddressInformationCardSaga';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, resetAddressInformation, setAddressInformation, setSelectedAddress, setShowSavedAddress } from '../AddressInformationCardSlice';
import { componentKey as dataLoaderKey } from '../../../../loaders/dataloader/DataLoaderSlice';
import { componentKey as paymentDrawerKey } from '../../PaymentDrawerSlice';
import { generalValidator } from '../../../../../../libs/utility/validators/GeneralValidator';
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown';
import Checkbox from '../../../../../components/checkbox/basecheckbox/Checkbox';
import { setSaveAddress } from '../../PaymentDrawerSlice';
import General from '../../../../../../libs/utility/General';

export default function AddNewAddress() {
    const [showNewAddress, SetShowNewAddress] = useState(false)
    const dispatch = useDispatch();
    const { loadingState, allRequiredFieldsTouched,  addressInformation } = useSelector(state => state[componentKey]);
    const { countriesList, statesList } = useSelector(state => state[dataLoaderKey]);
    const { saveAddress } = useSelector(state => state[paymentDrawerKey]);

    const { Address, Country, State, City, ZIP, Email } = addressInformation;

    useEffect(() => {
        if(showNewAddress) {
            dispatch(resetAddressInformation());
            dispatch(setShowSavedAddress(false))
            setDefaultCountry();
            dispatch(setSelectedAddress({ label: 'Select an address', value: null }));
        } else {
            dispatch(setShowSavedAddress(true))
        }
    }, [showNewAddress])

    const setDefaultCountry = () => {
        const USA = countriesList.find(c => c.Country_code == "US");

        if (USA) {
            dispatch(setAddressInformation({ ["Country"]: USA }))
        }
    }

    const onChangeHandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setAddressInformation({ [name]: { value, errors, rules } }))
        } else {
            dispatch(setAddressInformation({ [name]: { value } }))
        }
    }

    const zipCode = General.formatZipCode(ZIP?.value)

  return (
    <div style={styles.flexColumn}>
        <div style={styles.selfAlignEnd}>
            <IconLabel
                onClickCb={() => SetShowNewAddress((prev) => !prev)}
                containerStyles={styles.iconLabelContainer}
                text=" Add New Address"
                icon={VEC_ICON_NAME.CIRCULAR_PLUS_ICON}
                labelStyles={styles.pointer}
            />
        </div>
        {
            showNewAddress &&

            <div style={{ ...commonStyles.formContainer, ...commonStyles.drawerCard }}>
                <TextInput
                    name="Address"
                    label="Address"
                    value={Address?.value}
                    rules={Address?.rules}
                    errors={Address?.errors}
                    formSubmitted={allRequiredFieldsTouched}
                    onChangeCb={onChangeHandler}
                />

                <TextInput
                    name="City"
                    label="City"
                    value={City?.value}
                    rules={City?.rules}
                    errors={City?.errors}
                    formSubmitted={allRequiredFieldsTouched}
                    onChangeCb={onChangeHandler}
                />

                <div style={styles.stateRow}>
                    {   "US" ?
                            <SelectDropdown
                                label="State"
                                name="State"
                                options={statesList}
                                dropdownContainerStyles={{ width: "100%" }}
                                value={State}
                                onSelectCb={(name, selectedOption) => dispatch(setAddressInformation({ [name]: selectedOption }))}
                                rules={State?.rules}
                                errors={State?.errors}
                                formSubmitted={allRequiredFieldsTouched}
                            />

                            :

                            <TextInput
                                label="State"
                                name="State"
                                value={State.label}
                                onChangeCb={(e) => dispatch(setAddressInformation({ [e.target.name]: { label: e.target.value, value: e.target.value } }))}
                                rules={State?.rules}
                                errors={State?.errors}
                                formSubmitted={allRequiredFieldsTouched}
                            />
                    }


                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[ADDRESS_INFORMATION_LOADING_STATES.ZIP_VALIDATION_LOADING]}
                        messageMap={ADDRESS_INFORMATION_MESSAGE_MAP}
                        isNewLoadable={true}
                    >
                        <TextInput
                            name="ZIP"
                            label="Zip"
                            containerStyles={{ width: "75%" }}
                            value={zipCode}
                            onChangeCb={onChangeHandler}
                            onBlurCb={() => dispatch(validateZipCode(addressInformation))}
                            rules={ZIP?.rules}
                            errors={ZIP?.errors}
                            formSubmitted={allRequiredFieldsTouched}
                        />
                    </Loadable>
                </div>

                <SelectDropdown
                    label="Country"
                    name="Country"
                    options={countriesList}
                    value={{ label: Country.label, value: Country.value }}
                    onSelectCb={(name, selectedOption) => dispatch(setAddressInformation({ [name]: selectedOption }))}
                    rules={Country?.rules}
                    errors={Country?.errors}
                    formSubmitted={allRequiredFieldsTouched}
                />

                <div style={styles.addAddressCheckboxDiv}>
                    <Checkbox name='isSaveCard'  checked={saveAddress} onChangeCb={(e) => dispatch(setSaveAddress(e.target.checked))} />
                    Save Address?
                </div>
            </div>
        }
    </div>
  )
}